<script>
import ButtonGroup from 'element-ui/lib/button-group';

export default ButtonGroup;
</script>

<style lang="scss">
@import '~@/stylesheets/element-theme/button-group.css';

.el-button-group {
  .el-button + .el-button {
    margin: 0;
  }
}
</style>
